import React from 'react';
import styled, { keyframes } from 'styled-components';

const drift = keyframes`
  0% {
    transform: translate(-10%, 0) scale(0.9);
    opacity: 0.35;
  }
  50% {
    transform: translate(10%, -5%) scale(1.1);
    opacity: 0.55;
  }
  100% {
    transform: translate(25%, -15%) scale(1.3);
    opacity: 0.25;
  }
`;

const pulse = keyframes`
  0% { opacity: 0.25; }
  50% { opacity: 0.45; }
  100% { opacity: 0.25; }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 2;
  mix-blend-mode: screen;
  opacity: 0.5;

  @media (max-width: 768px) {
    opacity: 0.35;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 20% 20%, rgba(247, 198, 84, 0.15), transparent 50%),
                radial-gradient(circle at 80% 30%, rgba(255, 255, 255, 0.08), transparent 55%);
    filter: blur(40px);
    animation: ${pulse} 8s ease-in-out infinite;
  }
`;

const Smoke = styled.span`
  position: absolute;
  width: 45vw;
  height: 45vw;
  max-width: 900px;
  max-height: 900px;
  background: radial-gradient(circle, rgba(255,255,255,0.18) 0%, rgba(5,5,8,0) 60%);
  filter: blur(35px);
  animation: ${drift} 18s linear infinite;
  opacity: 0.35;

  &:nth-child(1) {
    top: 10%;
    left: -15%;
    animation-duration: 26s;
  }

  &:nth-child(2) {
    bottom: -20%;
    right: -10%;
    animation-duration: 22s;
    animation-delay: 4s;
  }

  &:nth-child(3) {
    top: 40%;
    left: 30%;
    animation-duration: 28s;
    animation-delay: 8s;
  }
`;

const BlackFridayOverlay = () => (
  <Overlay aria-hidden="true">
    <Smoke />
    <Smoke />
    <Smoke />
  </Overlay>
);

export default BlackFridayOverlay;

